<template>

<van-popup v-model="popupshow" position="right" :overlay="true" class="popupleft">
  <!--头部-->
  <van-nav-bar title="选择地址" fixed left-arrow @click-left="chooseSiteShow"></van-nav-bar>
  <!--地址-->
  <div class="van-content">
    <van-address-list v-model="chosenAddressId" @edit="amendSite" :list="siteList" v-if="siteList[0].id != ''">
    </van-address-list>
    <van-cell-group v-else>
      <van-cell>添加收货地址</van-cell>
    </van-cell-group>
  </div>
  <router-link to="/user/mysite/addsite"><van-button size="large" class="theme-bd theme-bg">添加收货地址</van-button></router-link>
</van-popup>

</template>

<script>
  export default {
    name: "choosesite",
    data () {
      return {
        popupshow:false,
        chosenAddressId: '',
        siteList: [
          {
            id: '',
            name: '',
            tel: '',
            address: ''
          }
        ]
      }
    },
    watch:{
      chosenAddressId:function () {
        if(this.popupshow == true){
          var site
          var _this = this
          $.each(this.siteList,function (index,item) {
            if(item.id == _this.chosenAddressId){
              site = item
            }
          })
          this.chooseSiteShow()
          this.$emit("listenSitedata",site,this.chosenAddressId)
        }
      }
    },
    methods:{
      amendSite:function (item, index) {
        this.$router.push({path:'/user/mysite/amendsite',query:{id:item.id}})
      },
      chooseSiteShow:function () {
        this.popupshow = !this.popupshow
      },
      chooseSite:function () {
        this.$refs.ChooseSite.chooseSiteShow()
      },
      getDatas:function () {
        var isUser = localStorage.getItem("BLHuser")
        var _this = this
        this.$api.get('WebApi/Member/Address/index', {token:isUser}, res => {
          if(res.data.data != null){
            this.siteList = []
            $.each(res.data.data,function (index,item) {
              if(item.moren == 1){
                _this.chosenAddressId = item.id
              }
              var siteObj = {id:item.id,name:item.name,tel:item.mobile,address:item.addressInfo + item.address}
              _this.siteList.push(siteObj)
            })
          }
        })
      },
    },
    mounted () {
      this.getDatas()
    },
  }
</script>

<style lang="less" scoped>
  .addSiteBtn{
    border-right: 0;
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    button{
      border-radius: 6px;
      border: none;
      width: 100%;
      float: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/affirmorder/choosesite.vue